import { render } from "./ModalAddCustomer.vue?vue&type=template&id=6960ef57&scoped=true"
import script from "./ModalAddCustomer.vue?vue&type=script&lang=js"
export * from "./ModalAddCustomer.vue?vue&type=script&lang=js"

import "./ModalAddCustomer.vue?vue&type=style&index=0&id=6960ef57&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6960ef57"]])

export default __exports__